import { CloudflareAccountsFormValidationSchema, DomainsApiProviders } from '@/modules/DomainsApi';

export const cloudflareAccountsFormValidationSchema: CloudflareAccountsFormValidationSchema = {
  email: [
    { required: true, message: 'Введіть назву e-mail' },
    { type: 'email', message: 'E-mail має бути валідним' }
  ],
  password: [
    { required: true, message: 'Введіть пароль від акаунту' },
    { type: 'string', message: 'Пароль від акаунту має бути строкою' },
    { min: 1, max: 255, message: 'Пароль від акаунту має бути довжиною не менше 1 символа та не більше 255' }
  ],
  apiKey: [
    { required: true, message: 'Введіть API ключ акаунту' },
    { type: 'string', message: 'API ключ акаунту має бути строкою' },
    { min: 1, max: 255, message: 'API ключ акаунту має бути довжиною не менше 1 символа та не більше 255' }
  ],
  provider: [{ required: true, type: 'enum', enum: [DomainsApiProviders.Cloudflare] }]
};
